<template>
  <v-app id="schedule" light class="calendar-app">
    <v-sheet tile dark height="66">
      <v-toolbar flat height="64">
        <div class="d-flex align-center" style="cursor:pointer" @click="toPage('/blog/home')">
          <v-img alt="Logo" class="shrink mr-2" contain dark width="40" height="40"
            :src="logo" transition="scale-transition"/>
          <span class="logo-name">{{ logoName }}</span>
        </div>
        <v-btn icon @click="$refs.calendar.prev()" style="margin-left:6%"color="#29B6F6">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar" class="calendar-title">{{ $refs.calendar.title }}</v-toolbar-title>
        <v-btn text color="#B2FF59" @click="setType('month')" style="margin-left:12px;font-size:15px">月视图</v-btn>
        <v-btn text color="#B2FF59" @click="setType('week')" style="margin-left:12px;font-size:15px">周视图</v-btn>
        <v-btn text color="#B2FF59" @click="setType('day')" style="margin-left:12px;font-size:15px">日视图</v-btn>
        <v-toolbar-title  style="margin-left:20px;font-size:15px;color:#1DE9B6">
          今日任务:<b style="color:#FF1744;margin-left:5px;margin-right:2px">{{ todayTaskTotal }}</b>个<i style="margin-right:8px"></i>
          已完成:<b style="color:#BDBDBD;margin-left:5px;margin-right:2px">{{ todayTaskCompleted }}</b>个<i style="margin-right:8px"></i>
          明日任务:<b style="color:#76FF03;margin-left:5px;margin-right:2px">{{ tomorrowTaskTotal }}</b>个<i style="margin-right:8px"></i>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="marquee">
          <div class="marquee_box">
            <ul class="marquee_list" :class="{marquee_top:animate}">
              <li v-for="(item, index) in marqueeList" :key="index">
                <span class="marquee_title">{{item.title}} </span>
                <span class="marquee_descption"> {{item.subtitle}} </span>
                <span class="marquee_descption"> {{item.descption}} </span>
              </li>
            </ul>
          </div>
        </div>
        <v-btn icon color="#26A69A" @click="$refs.calendar.next()" style="margin-right:6%">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-toolbar>
    </v-sheet>
    
    <v-row>
      <v-col sm="12" lg="2">
        <v-card class="calendar-card" light>
            <v-img height="200" :src="PNG">
              <v-card-title><p style="color:#E65100;font-weight:700">今日任务</p></v-card-title>
            </v-img>

            <v-subheader><p style="color:#E53935;font-weight:700">进行中</p></v-subheader>
            <v-virtual-scroll
              :items="working"
              :item-height="100"
              height="110"
            >
              <template v-slot="{ item }">
                <v-list flat>
                  <v-list-item-group color="#66BB6A">
                    <v-list-item
                      :key="item.name">
                      <v-list-item-icon>
                        <v-avatar size="75" :color="item.color"><v-img :src="item.icon"/></v-avatar>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title><p style="color:#B71C1C">{{item.name}}</p></v-list-item-title>
                    <v-list-item-subtitle><p style="color:#B71C1C">用时: {{item.timeSpent}}     <span style="padding-left:10px">来源: {{ item.source}}</span></p></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </template>
            </v-virtual-scroll>

            <v-divider></v-divider>

            <v-subheader><p style="color:#00C853;font-weight:700">未开始</p></v-subheader>
            <v-virtual-scroll
              :items="preparing"
              :item-height="90"
              height="280"
            >
              <template v-slot="{ item }">
                <v-list flat>
                  <v-list-item-group color="#66BB6A">
                    <v-list-item
                      :key="item.name">
                      <v-list-item-icon>
                        <v-avatar size="60" :color="item.color"><v-img :src="item.icon"/></v-avatar>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title><p style="color:#1B5E20">{{item.name}}</p></v-list-item-title>
                    <v-list-item-subtitle><p style="color:#1B5E20">用时: {{item.timeSpent}}     <span style="padding-left:10px">来源: {{ item.source}}</span></p></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </template>
            </v-virtual-scroll>

            <v-divider></v-divider>

            <v-subheader><p style="color:#546E7A;font-weight:700">已完成</p></v-subheader>
            <v-virtual-scroll
              :items="completed"
              :item-height="80"
              height="330"
            >
              <template v-slot="{ item }">
                <v-list flat>
                  <v-list-item-group color="#66BB6A">
                    <v-list-item
                      :key="item.name">
                      <v-list-item-icon>
                        <v-avatar size="56" :color="item.color"><v-img :src="item.icon" /></v-avatar>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title><p style="color:#757575">{{item.name}}</p></v-list-item-title>
                        <v-list-item-subtitle><p style="color:#757575">用时: {{item.timeSpent}}     <span style="padding-left:10px">来源: {{ item.source}}</span></p></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </template>
            </v-virtual-scroll>
        </v-card>
      </v-col>
      <v-col sm="12" lg="10">
        <v-sheet height="88%" width="95%" class="calendar-sheet">
          <v-calendar
            light
            ref="calendar"
            v-model="focus"
            color="#EA80FC"
            :weekdays="weekday"
            :type="type"
            :now="today"
            :events="events"
            :event-overlap-mode="mode"
            :event-overlap-threshold="30"
            :event-color="getEventColor"
            @change="getEvents"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
          ></v-calendar>
          <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card min-width="320px" flat dark>
                <v-toolbar height="40px">
                  <v-toolbar-title>任务详情</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon color="#FF8A80" @click="selectedOpen = false"><v-icon>fa-times-circle</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-list dense>
                    <v-list-item-group v-model="listItem" color="#1DE9B6">
                      <v-list-item v-for="(val, key, i) in eventTitle" :key="i">
                        <v-list-item-title>{{ val }}: </v-list-item-title>
                        <v-list-item-subtitle><i style="color:#F5F5F5">{{ selectedEvent[key] }}</i>
                        </v-list-item-subtitle>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    
  </v-app>
</template>

<script>
  import CONFIG from '@/config/config.js';
  import SCHEDULE from '@/config/schedule.js'
  import PNG from '@/assets/imgs/calendar/spring2.jpg'
  export default {
    data (){
      return{
        PNG,
        type: 'month',
        mode: 'stack',
        weekday: [0, 1, 2, 3, 4, 5, 6],
        focus: '',
        listItem:"",
        _timer:null,
        schedule: SCHEDULE.items,
        events: [],
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        firstInterval:9,
        eventTitle:{
          name:"任务名",
          source:"任务来源",
          state:"状 态",
          priority:"优先级",
          timeSpent:"花 费",
          start:"起始时间",
          end:"结束时间",
        },
        marqueeList:[],
        animate: false,
        todayTaskTotal:0,
        todayTaskCompleted:0,
        tomorrowTaskTotal:0,
        working:[],
        completed:[],
        preparing:[]
      }
    },
    computed:{
      today(){
        let tDate = new Date();
        let tMonth = tDate.getMonth() + 1;
        return tDate.getFullYear()+"-"+tMonth+"-"+tDate.getDate()+" "+tDate.getHours()+":00:00"
      },
      logoName: function () {
        return CONFIG.TITLE
      },
      logo:function () {
        return CONFIG.LOGO
      }
    },
    filters: {
      cookState(value) {
        if(value == 1){
          return "进行中"
        }else if(value == 2){
          return "未开始"
        }else if(value == 3){
          return "已完成"
        }
      },
      cookLength(value) {
        if(value && value.length >= 16){
          return value.substring(0, 17) + "...";
        }else{
          return value;
        }
        
      },
    },
    methods: {
      getEvents ({ start, end }) {
        let _this = this;
        _this.events = []
        let data = _this.schedule;
        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const date = new Date();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        for (let item of data) {
          const startDate = item.start;
          const start = new Date(startDate);
          const startYear = start.getFullYear();
          const startMonth = start.getMonth() + 1;
          if(startYear == year && startMonth == month){
            _this.events.push({
              name: item.name,
              start: item.start,
              end: item.end,
              priority: item.priority,
              state: item.state,
              source:item.source,
              timeSpent:item.timeSpent,
              time:true,
            })
          }
        }
      },
      getTaskTotal(){
        let _this = this;
        let data = _this.schedule;
        const date = new Date(new Date(new Date().getTime()).setHours(0,0,0,0));
        let today = new Date(new Date(new Date().getTime()).setHours(0,0,0,0));
        let tomorrow = today.setDate(today.getDate()+1);
        tomorrow = new Date(tomorrow);
        for (let item of data) {
          const startDate = item.start;
          const start = new Date(new Date(new Date(startDate).getTime()).setHours(0,0,0,0));
          const endDate = item.end;
          const end = new Date(new Date(new Date(endDate).getTime()).setHours(0,0,0,0));
          if(start <= date && date <= end){
            _this.todayTaskTotal += 1;
            if(item.state == 3){
              _this.todayTaskCompleted += 1;
              item.icon = _this.cookIcon(3);
              item.color = _this.cookColor();
              _this.completed.push(item);
            }else if(item.state == 2){
              item.icon = _this.cookIcon(2);
              item.color = _this.cookColor();
              _this.preparing.push(item);
            }else if(item.state == 1){
              item.icon = _this.cookIcon(1);
              item.color = _this.cookColor();
              _this.working.push(item);
            }
          }
          if(start <=  tomorrow && tomorrow <= end){
            _this.tomorrowTaskTotal += 1;
          }
        }
      },
      getEventColor (event) {
        let priority = event.priority;
        let state = event.state;
        if(state === 3){
          return "#E0E0E0"
        }else if(state === 1){
          if(priority == 1){
            return "#FF1744"
          }else if(priority == 2){
            return "#EF5350"
          }else if(priority == 3){
            return "#D500F9"
          }else if(3<priority<7){
            return "#3D5AFE"
          }else{
            return "#64B5F6"
          }
        }else if(state === 2){
          if(priority == 1){
            return "#FFA726"
          }else if(priority == 2){
            return "#FFF176"
          }else if(priority == 3){
            return "#B2FF59"
          }else if(3<priority<7){
            return "#84FFFF"
          }else{
            return "#E6EE9C"
          }
        }
        return "#B2DFDB"
      },
      viewDay ({ date }) {
        this.focus = date;
        this.type = 'day';
      },
      getToday () {
        let date = new Date();
        let month = date.getMonth() + 1;
        return date.getFullYear() +"-" + month + "-" + date.getDay();
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => this.selectedOpen = true, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      setType(value){
        this.type = value;
      },
      // 获取日期
      getDate() {
        let _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let week = new Date().getDay();
        let hh = new Date().getHours();
        let _mf = new Date().getMinutes();
        let mf = _mf< 10? "0"+_mf: _mf;
        let _ss = new Date().getSeconds();
        let ss = _ss < 10? "0"+_ss: _ss;
        let nowWeek = "";
        if (week == 1) {
          nowWeek = "周一";
        } else if (week == 2) {
          nowWeek = "周二";
        } else if (week == 3) {
          nowWeek = "周三";
        } else if (week == 4) {
          nowWeek = "周四";
        } else if (week == 5) {
          nowWeek = "周五";
        } else if (week == 6) {
          nowWeek = "周六";
        } else {
          nowWeek = "周日";
        }
        let nowDate = yy + "-" + mm + "-" + dd;
        let nowTime =  hh + ":" + mf + ":" + ss;
        let localCity = _this.$store.state.localWeather.localCity || "杭州";
        let localCountry = _this.$store.state.localWeather.localCountry || "中国";
        let dateData = {
          title: localCountry + " · " + localCity,
          subtitle: nowDate + " " + nowTime,
          descption: nowWeek,
          _index:1
        }
        return dateData;
      },
      // 获取本地天气
      getWeather() {
        let _this = this;
        let todayWeather = _this.$store.state.localWeather.todayWeatherStr;
        let todayTemperature = _this.$store.state.localWeather.todayTemperatureStr;
        let tomorrowWeather = _this.$store.state.localWeather.tomorrowWeatherStr;
        let tomorrowTemperature = _this.$store.state.localWeather.tomorrowTemperatureStr;
        _this.marqueeList.push({
          title: "今日天气",
          subtitle: todayWeather,
          descption:todayTemperature,
          day:"",
          _index:2
        })
        _this.marqueeList.push({
          title: "明日天气",
          subtitle: tomorrowWeather,
          descption:tomorrowTemperature,
          _index:3
        })
      },
      showMarquee() {
        let _this = this;
        _this.animate = true;
        setTimeout(()=>{
          let first = _this.marqueeList[0];
          if(first._index === 1){
            first = _this.getDate();
          }else{
            let day = new Date().getDate();
            let update_day = _this.$store.state.localWeather.update_day;
            if(day !== update_day){
              _this.marqueeList = [];
              first = _this.getDate();
              _this.getWeather();
            }
          }
          _this.marqueeList.push(first);
          _this.marqueeList.shift();
          _this.animate = false;
        }, 1000)
      },
      toPage(url){
        this.$router.push({path: url})
      },
      cookIcon(state){
        if(state ===1){
          let index =  Math.ceil(Math.random()*32);
          index = index + 100;
          let jpg = require("../assets/imgs/project/"+index+".jpg");
          return jpg;
        }else if(state ===2){
          let index =  Math.ceil(Math.random()*27);
          let jpg = require("../assets/imgs/project/"+index+".jpg");
          return jpg;
        }else{
          let index =  Math.ceil(Math.random()*59);
          index = index>27?index+74:index;
          let jpg = require("../assets/imgs/project/"+index+".jpg");
          return jpg;
        }
      },
      cookColor(){
        return '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).substr(-6);
      }
    },
    mounted() {
      let _this = this;
      _this.getTaskTotal();
      let dateData = _this.getDate();
      _this.marqueeList.push(dateData);
      _this.getWeather();
      if (_this._timer) clearInterval(_this._timer);
      this._timer = setInterval(() => {
        this.showMarquee();
      }, 2000); 
    },
    beforeDestroy() {
      if (this._timer) clearInterval(this._timer);
    }
  }
</script>

<style lang="stylus" scoped>
.calendar-app
  width 100%
  height 100%
  position relative
  background-size cover
  background-image url("../assets/imgs/calendar/spring.jpg")

.logo-name
  font-size 15px

.calendar-title
  font-size 15px
  color #00E676

.calendar-sheet
  margin-left 3%
  margin-top 30px
  opacity 0.8

.calendar-card
  margin-left 5%
  margin-top 30px
  opacity 0.8

.marquee
	width 360px
	height 40px
	color #FF6D00
	display relative
  font-size 10px
	box-sizing border-box

.marquee_box
	display block
	position relative
	width: 100%
	height 36px
	overflow hidden

.marquee_list
	display block

.marquee_top
	transition all 0.5s
	margin-top -30px

.marquee_list li
	height 30px
	line-height 30px
	font-size 12px
  color #FB8C00

.marquee_descption
  margin-left 10px
  font-size 15px

.marquee_title
  font-size 15px

</style>